import React, { type MutableRefObject } from 'react';
import {
    DataGridPremium,
    type DataGridPremiumProps,
    type GridApiPremium,
    type GridDataSource,
} from '@mui/x-data-grid-premium';
import Box from '@mui/material/Box';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import { styleEditedRow } from '../utils/BulkEditHelper.tsx';
import type { GridColumnVisibilityModel, GridFilterModel } from '@mui/x-data-grid';
export default function MuiGridWithConnector({
    dataSource,
    featureColumns,
    apiRef,
    processRowUpdate,
    isSaving,
    getRowClassName,
    getCellClassName,
    initialState,
    getDetailPanelContent,
    onDetailPanelExpandedRowIdsChange,
    columnVisibilityModel,
    filterModel,
}: {
    dataSource: GridDataSource;
    featureColumns: any[];
    apiRef: MutableRefObject<GridApiCommunity | GridApiPremium | null>;
    processRowUpdate: NonNullable<DataGridPremiumProps['processRowUpdate']>;
    isSaving: boolean;
    getRowClassName: NonNullable<DataGridPremiumProps['getRowClassName']>;
    getCellClassName: NonNullable<DataGridPremiumProps['getCellClassName']>;
    initialState?: DataGridPremiumProps['initialState'];
    getDetailPanelContent: any;
    onDetailPanelExpandedRowIdsChange: any;
    columnVisibilityModel: GridColumnVisibilityModel;
    filterModel?: GridFilterModel | null;
}): React.JSX.Element {
    return (
        <Box style={{ flex: 1, minHeight: '200px', width: '100%' }}>
            <DataGridPremium
                disableColumnSelector
                disableColumnFilter
                columns={featureColumns}
                sortingMode='client'
                dataSource={dataSource}
                onDataSourceError={console.error}
                getRowClassName={getRowClassName}
                getCellClassName={getCellClassName}
                getRowId={(row) => row.rowId}
                disableRowSelectionOnClick
                apiRef={apiRef}
                processRowUpdate={processRowUpdate}
                columnVisibilityModel={columnVisibilityModel}
                initialState={initialState}
                filterModel={filterModel ?? undefined}
                sx={{
                    [`.row--edited`]: {
                        backgroundColor: (theme) => {
                            return styleEditedRow(theme);
                        },
                    },
                    [`.cell--edited`]: {
                        border: '1px dashed #ff8500db',
                    },
                }}
                loading={isSaving}
                onProcessRowUpdateError={console.error}
                disablePivoting
                getDetailPanelContent={getDetailPanelContent}
                onDetailPanelExpandedRowIdsChange={onDetailPanelExpandedRowIdsChange}
                getDetailPanelHeight={() => 'auto'}
            />
        </Box>
    );
}
